import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { CenteredMessage } from '../CenteredMessage';
import { HorizontalFlexContainer } from '../style/LayoutComponents';
import { cssClass } from '../style/StyleFunctions';


const emptyGridContainerClass = cssClass('emptyGridContainer', {
  height: '100%'
});

export type EmptyGridElementProps = {
  readonly emptyGridMessage?: string;
};

export function EmptyGridElement(props: EmptyGridElementProps): JSX.Element {
  return (
    <HorizontalFlexContainer additionalClassNames={[emptyGridContainerClass]}>
      <CenteredMessage message={props.emptyGridMessage || Messages.EmptyContentMessage()} />
    </HorizontalFlexContainer>
  );
}
